// extracted by mini-css-extract-plugin
module.exports = {"icon":"Checkbox_icon__06cQR","box":"Checkbox_box__Ex3_X"};